import React, { useState, useEffect } from "react";
import { PaginaCarga } from "../../Componentes/Compuestos/Paginas/PaginaCarga";
import { function_VEN_Reservas_Integrantes_Generar_JSONModificarAgasajado, function_VEN_Reservas_Integrantes_Generar_JSONModificarCheckIn, function_VEN_Reservas_Integrantes_Leer, function_VEN_Reservas_Integrantes_ModificarCheckIn } from "neftis7_apicaller/src/funciones/VEN/Reservas/VEN_Reservas_Integrantes";
import { useParams } from "react-router-dom";
import { FormateoFechaPara_yyyyMMdd_HHmmss } from "neftis7_apicaller/src/funciones/Varios";

export const VEN_Reservas_Integrantes_EjecutarCheckIn = () => {
  const [loading, setLoading] = useState(false)
  const [cliente, setCliente] = useState(null);
  const [error, setError] = useState(false);
  const { CodigoCompania, CodigoEmpresa, CodigoPlanta, IdReserva, IdItem, IdCliente } = useParams();
  const [yaIngreso, setYaIngreso] = useState(false);
  const [fechaIngreso, setFechaIngreso] = useState(null);
  const [ingresoRealizado, setIngresoRealizado] = useState(false);

  useEffect(() => {
    const buscarParticipante = async () => {
      try {
        setLoading(true);

        const resultIntegrantes = await function_VEN_Reservas_Integrantes_Leer(IdItem, IdReserva)

        if (resultIntegrantes.data) {
          const encontrado = (resultIntegrantes.data || []).find(x => Number(x.IdCliente) === Number(IdCliente));

          if (encontrado) {
            setCliente(encontrado.Cliente);

            console.log(encontrado.FechaCheckIn)
            if (encontrado.FechaCheckIn && new Date(encontrado.FechaCheckIn) > new Date('2020-01-01')) {
              setYaIngreso(true);
              setFechaIngreso(new Date(encontrado.FechaCheckIn).toLocaleDateString('es-AR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
              }));
            } else {
              setYaIngreso(false);
            }

            setError(false);
          } else {
            setError(true);
          }
        } else {
          setError(true);
        }
      } catch (err) {
        alert("Error: " + err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    buscarParticipante();
  }, []);

  const handleOnClick_CheckIn = async () => {
    try {
      const JSON = await function_VEN_Reservas_Integrantes_Generar_JSONModificarCheckIn(IdReserva, IdItem,
        IdCliente, "", "--", await FormateoFechaPara_yyyyMMdd_HHmmss(new Date()))

        console.log(JSON)
      await function_VEN_Reservas_Integrantes_ModificarCheckIn(JSON)

      setIngresoRealizado(true); // ✅ Marcar que se hizo el ingreso
    } catch (error) {
      alert("❌ Error al hacer Check In: " + (error.message || error));
    } finally {
      setLoading(false);
    }
  }

  return (
    <PaginaCarga Titulo="EJECUTAR CHECK IN">
      {loading ? (
        <div className="spinner-border" role="status">
          <span className="sr-only">Cargando...</span>
        </div>
      ) : error ? (
        <div style={{ color: 'red', fontSize: '20px', textAlign: 'center', marginTop: '30px' }}>
          No se pudo encontrar el participante.
        </div>
      ) : (
        <div style={{ textAlign: 'center', marginTop: '30px' }}>
          <h2>{cliente}</h2>

          {yaIngreso ? (
            <div style={{ color: 'red', fontSize: '18px', marginTop: '20px' }}>
              {cliente} ya ha ingresado el {fechaIngreso}.
            </div>
          ) : ingresoRealizado ? (
            <div style={{ color: 'green', fontSize: '22px', marginTop: '20px' }}>
              ✅ Se ha realizado el ingreso
            </div>
          ) : (
            <button
              onClick={handleOnClick_CheckIn}
              style={{
                marginTop: '20px',
                padding: '20px 40px',
                backgroundColor: 'green',
                color: 'white',
                fontSize: '24px',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer'
              }}
            >
              INGRESO
            </button>
          )}
        </div>
      )}
    </PaginaCarga>
  );
};
